<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
  >
    <a-form-model-item label="父级标签" prop="paraent">
      <a-select v-model="form.parentId" style="width: 100%" placeholder="请选择父级标签">
        <a-select-option :value="-1"> 无 </a-select-option>

        <a-select-option v-for="root in roots" :key="root.spiderTagId" :value="root.spiderTagId">
          {{ root.spiderTagName }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="标签名称" prop="spiderTagName">
      <a-input v-model="form.spiderTagName" placeholder="请输入标签名称" />
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        {{ formModel ? '修 改' : '创 建' }}
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm"> 重 置 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { createTagApi, updateTagApi } from '@/api/System/Tags'

export default {
  props: {
    roots: Array,
    formModel: Object
  },

  data() {
    return {
      rules: {
        spiderTagName: [{ required: true, message: '标签名必填', trigger: ['change', 'blur'] }]
      },
      form: {}
    }
  },

  created() {
    this.resetForm()
  },

  watch: {
    roots: {
      handler(val) {
        console.log(val)
      }
    }
  },

  methods: {
    resetForm() {
      if (this.formModel) {
        this.form = { ...this.formModel }
      } else {
        this.form = {
          parentId: -1,
          spiderTagName: ''
        }
      }
    },

    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateUser()
          } else {
            this.createUser()
          }
        }
      })
    },

    async updateUser() {
      const res = await updateTagApi({
        ...this.form,
        level: this.form.parentId === -1 ? 1 : 2
      })
      let { code, msg } = res

      if (code === 200) {
        this.$emit('refresh', false)
      } else {
        this.$message.error(msg)
      }
    },

    async createUser() {
      const res = await createTagApi({
        ...this.form,
        level: this.form.parentId === -1 ? 1 : 2
      })
      let { code, msg } = res

      if (code === 200) {
        this.$emit('refresh', true)
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>
